
(function(){
"use strict";
function setup(root){
 if(!root || root.dataset.ndisReady==="1")return;
 var form=root.querySelector("form.ael-ndis-form");
 if(!form || !root.querySelector("[data-ndis-step]"))return;
 root.dataset.ndisReady="1";
 var steps=Array.from(root.querySelectorAll("[data-ndis-step]"));
 var markers=Array.from(root.querySelectorAll("[data-ndis-marker]"));
 var error=root.querySelector("[data-ndis-error]");
 var catalog=Array.from(root.querySelectorAll("[data-ndis-option]")).map(function(node){
  return {node:node,handle:node.dataset.handle||"",title:node.dataset.title||"",image:node.dataset.image||"",price:Number(node.dataset.price)||0,variants:Array.from(node.querySelectorAll("[data-ndis-variant]")).map(function(v){return {id:v.dataset.id,title:v.dataset.title,price:Number(v.dataset.price)||0}})};
 }).filter(function(p){return !!p.handle});
 var selected=[];
 var chooser=root.querySelector("[data-ndis-picker]");
 var trigger=root.querySelector("[data-ndis-picker-toggle]");
 var menu=root.querySelector("[data-ndis-picker-menu]");
 var search=root.querySelector("[data-ndis-search]");
 var empty=root.querySelector("[data-ndis-no-results]");
 var cards=root.querySelector("[data-ndis-selected]");
 var summaries=root.querySelector("[data-ndis-summary-items]");
 var qtyMax=25,step=1;

 
/* Add a clear Done Selecting button to the dropdown */
var doneButton = null;

if (menu) {
  doneButton = document.createElement("button");
  doneButton.type = "button";
  doneButton.className = "ndis-picker-done";
  doneButton.textContent = "✓ Done selecting";

  menu.appendChild(doneButton);

  doneButton.addEventListener("click", function() {
    closeMenu(true);
  });
}

 
/* Automatically remember NDIS product selections */
var NDIS_STORAGE_KEY = "ael_ndis_product_selections_v1";
var NDIS_STORAGE_DURATION = 30 * 24 * 60 * 60 * 1000;

function saveProductChoices() {
  try {
    if (!selected.length) {
      localStorage.removeItem(NDIS_STORAGE_KEY);
      return;
    }

    var items = selected.map(function(item) {
      return {
        handle: item.product.handle,
        variantId: item.variant ? String(item.variant.id) : null,
        quantity: item.quantity
      };
    });

    localStorage.setItem(
      NDIS_STORAGE_KEY,
      JSON.stringify({
        savedAt: Date.now(),
        items: items
      })
    );
  } catch (error) {
    // Continue normally if browser storage is unavailable.
  }
}

function restoreProductChoices() {
  try {
    var raw = localStorage.getItem(NDIS_STORAGE_KEY);
    if (!raw) return;

    var saved = JSON.parse(raw);

    if (
      !saved ||
      !Array.isArray(saved.items) ||
      !Number.isFinite(saved.savedAt) ||
      saved.savedAt > Date.now() ||
      Date.now() - saved.savedAt > NDIS_STORAGE_DURATION
    ) {
      localStorage.removeItem(NDIS_STORAGE_KEY);
      return;
    }

    selected = saved.items.map(function(item) {
      if (!item || typeof item.handle !== "string") {
        return null;
      }

      var product = catalog.find(function(p) {
        return p.handle === item.handle;
      });

      if (!product || !product.variants.length) {
        return null;
      }

      var variantId = item.variantId == null
        ? null
        : String(item.variantId);

      var variant = product.variants.find(function(v) {
        return v.id === variantId;
      }) || null;

      if (!variant && product.variants.length === 1) {
        variant = product.variants[0];
      }

      return {
        product: product,
        variant: variant,
        quantity: Math.min(
          qtyMax,
          Math.max(1, parseInt(item.quantity, 10) || 1)
        )
      };
    }).filter(Boolean);

  } catch (error) {
    selected = [];
  }
}

 var endpoint=(root.dataset.ndisDraftEndpoint||"").trim();
 var draftMode=root.dataset.ndisDraftEnabled==="true" && /^https:\/\//i.test(endpoint) && !!root.dataset.ndisTurnstileSiteKey;
 var requestId=(window.crypto && window.crypto.randomUUID)?window.crypto.randomUUID():"";
 function fmt(cents){return new Intl.NumberFormat("en-AU",{style:"currency",currency:"AUD"}).format(cents/100)}
 function el(tag,cls,value){var n=document.createElement(tag);if(cls)n.className=cls;if(value!==undefined)n.textContent=value;return n}
 function field(name){var e=form.elements.namedItem(name);return e && typeof e.value==="string"?e.value.trim():""}
 function requesterRole(){var option=form.querySelector('input[name="contact[Requester role]"]:checked');return option?option.value:""}
 function total(){return selected.reduce(function(s,item){return s+(item.variant?item.variant.price*item.quantity:0)},0)}
 function productLines(){return selected.map(function(row){return row.quantity+" × "+row.product.title+" - "+(row.variant?row.variant.title:"OPTION NOT SELECTED")+" (Variant ID "+(row.variant?row.variant.id:"none")+") = "+(row.variant?fmt(row.quantity*row.variant.price):"Pending selection")})}
 function addImage(parent,p,width){
  if(!p.image)return;var im=document.createElement("img");im.src=p.image;im.alt=p.title;im.width=width;im.height=width;im.loading="lazy";parent.appendChild(im)
 }
 function refresh(){
  if(cards){
   cards.replaceChildren();
   if(!selected.length)cards.appendChild(el("p","ndis-summary-empty","Choose a product from the search dropdown to begin."));
   selected.forEach(function(item){
    var line=el("div","ndis-product-card ndis-selected-product");
    addImage(line,item.product,70);
    var info=el("div","ndis-product-copy");
    info.appendChild(el("strong","",item.product.title));
    info.appendChild(el("span","",item.variant?fmt(item.variant.price):"Select an option for pricing"));
    if(item.product.variants.length>1){
     var vLabel=el("label","ndis-variant-label","Choose product option *");
     var vSelect=document.createElement("select");
     vSelect.className="ndis-variant-select";
     vSelect.setAttribute("aria-label","Choose an option for "+item.product.title);
     var placeholder=document.createElement("option");placeholder.value="";placeholder.textContent="Select size / colour / option";vSelect.appendChild(placeholder);
     item.product.variants.forEach(function(v){
      var opt=document.createElement("option");opt.value=v.id;opt.textContent=v.title+" — "+fmt(v.price);vSelect.appendChild(opt)
     });
     vSelect.value=item.variant?item.variant.id:"";
     vSelect.addEventListener("change",function(){
      item.variant=item.product.variants.find(function(v){return v.id===vSelect.value})||null;
      refresh()
     });
     vLabel.appendChild(vSelect);info.appendChild(vLabel)
    }
    
if (
  item.product.variants.length > 1 &&
  selected.find(function(row) {
    return row.product.handle === item.product.handle;
  }) === item
) {
  var addAnother = el(
    "button",
    "ndis-add-another-variant",
    "+ Add another option"
  );

  addAnother.type = "button";

  addAnother.addEventListener("click", function() {
    selected.push({
      product: item.product,
      quantity: 1,
      variant: null
    });

    refresh();
  });

  info.appendChild(addAnother);
}

    line.appendChild(info);
    var wrap=el("div","ndis-quantity-wrap");var label=el("label","ndis-product-qty-label","Qty");
    var input=document.createElement("input");input.type="number";input.min="1";input.max=String(qtyMax);input.step="1";
    input.value=String(item.quantity);input.setAttribute("aria-label","Quantity for "+item.product.title);
    label.appendChild(input);wrap.appendChild(label);line.appendChild(wrap);
    input.addEventListener("change",function(){item.quantity=Math.min(qtyMax,Math.max(1,Number.parseInt(input.value,10)||1));refresh()});
    var remove=el("button","ndis-product-remove","×");remove.type="button";remove.setAttribute("aria-label","Remove "+item.product.title);
    remove.addEventListener("click",function(){selected=selected.filter(function(x){return x!==item});refresh()});
    line.appendChild(remove);cards.appendChild(line)
   })
  }
  if(summaries){
   summaries.replaceChildren();
   if(!selected.length)summaries.appendChild(el("p","ndis-summary-empty","Select a product to see an estimated total."));
   selected.forEach(function(item){
    var row=el("div","ndis-summary-item");addImage(row,item.product,68);
    var name=el("div","ndis-summary-name",item.product.title);
    name.appendChild(el("small","",item.variant&&item.product.variants.length>1?item.variant.title+" · Qty: "+item.quantity:"Qty: "+item.quantity));
    row.appendChild(name);row.appendChild(el("span","ndis-summary-price",item.variant?fmt(item.variant.price*item.quantity):"Choose option"));
    summaries.appendChild(row)
   })
  }
  Array.from(root.querySelectorAll("[data-ndis-total]")).forEach(function(n){n.textContent=fmt(total())});
  if(trigger){trigger.textContent="";var text=el("span","",selected.length?"Add another product":"Search and select a product");trigger.appendChild(text);var chev=el("span","","⌄");chev.setAttribute("aria-hidden","true");trigger.appendChild(chev)}
  

if (search) filterOptions();

// Update the Done button with the selected product count
if (doneButton) {
  var productCount = new Set(
    selected.map(function(item) {
      return item.product.handle;
    })
  ).size;

  doneButton.textContent =
    "✓ Done selecting (" + productCount + ")";
}

saveProductChoices();

}

 

function filterOptions() {
  var needle = (search?.value || "")
    .trim()
    .toLocaleLowerCase();

  var visible = 0;

  catalog.forEach(function(p) {
    var match = !needle ||
      p.title.toLocaleLowerCase().includes(needle);

    var isSelected = selected.some(function(row) {
      return row.product.handle === p.handle;
    });

    p.node.hidden = !match;
    p.node.classList.toggle("is-selected", isSelected);

    var checkbox = p.node.querySelector(
      "[data-ndis-option-checkbox]"
    );

    if (checkbox) {
      checkbox.checked = isSelected;
    }

    if (match) visible++;
  });

  if (empty) {
    empty.hidden = visible > 0;
    empty.textContent = "No matching products found.";
  }
}


 
function openMenu(){
  if(!menu||!trigger||!catalog.length)return;

  menu.hidden=false;
  trigger.setAttribute("aria-expanded","true");

  if(search){
    search.value="";
    filterOptions();
  }
}

 function closeMenu(restoreFocus){
  if(!menu||!trigger)return;menu.hidden=true;trigger.setAttribute("aria-expanded","false");
  if(restoreFocus)trigger.focus()
 }
 if(trigger)trigger.addEventListener("click",function(){if(menu?.hidden)openMenu();else closeMenu(true)});
 if(search)search.addEventListener("input",filterOptions);
 if(search)search.addEventListener("keydown",function(e){if(e.key==="Escape"){e.preventDefault();closeMenu(true)}});
 

catalog.forEach(function(p) {
  var checkbox = p.node.querySelector(
    "[data-ndis-option-checkbox]"
  );

  if (!checkbox) return;

  checkbox.addEventListener("change", function() {

    if (checkbox.checked) {

      if (!selected.some(function(item) {
        return item.product.handle === p.handle;
      })) {
        selected.push({
          product: p,
          quantity: 1,
          variant: p.variants.length === 1
            ? p.variants[0]
            : null
        });
      }

    } else {

      selected = selected.filter(function(item) {
        return item.product.handle !== p.handle;
      });

    }

    
    // Update the visual selection immediately
    p.node.classList.toggle(
      "is-selected",
      checkbox.checked
    );

    // Allow the checkmark to display before
    // updating the product cards and summary
    requestAnimationFrame(function() {
      setTimeout(function() {
        refresh();
      }, 0);
    });

  });
});



 document.addEventListener("click",function(e){if(chooser && !chooser.contains(e.target))closeMenu(false)});
 function setStep(next,scroll){
  step=next;
  steps.forEach(function(s){var active=Number(s.dataset.ndisStep)===next;s.hidden=!active;s.classList.toggle("is-active",active)});
  markers.forEach(function(m){var i=Number(m.dataset.ndisMarker);m.classList.toggle("is-active",i===next);m.classList.toggle("is-done",i<next)});
  if(error){error.hidden=true;error.textContent=""}
  if(next===3)review();
  if(scroll!==false){var panel=root.querySelector("[data-ndis-form-panel]");if(panel)panel.scrollIntoView({behavior:"smooth",block:"start"})}
 }
 function showError(msg,focus){
  if(error){error.hidden=false;error.textContent=msg}
  if(focus)focus.focus()
 }
 function valid(n){
  var panel=root.querySelector('[data-ndis-step="'+n+'"]');if(!panel)return true;
  var bad=null;
  Array.from(panel.querySelectorAll("[data-ndis-required]")).forEach(function(i){
   var ok=i.type==="checkbox"?i.checked:!!String(i.value).trim();
   if(ok&&i.type==="email")ok=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(i.value.trim());
   if(ok&&i.pattern)try{ok=new RegExp("^(?:"+i.pattern+")$").test(i.value.trim())}catch(ignore){}
   if(!ok){i.setAttribute("aria-invalid","true");if(!bad)bad=i}else{i.removeAttribute("aria-invalid")}
  });
  if(n===1&&!requesterRole()){showError("Please tell us who is making this NDIS request.",root.querySelector("[data-ndis-requester]"));return false}
  if(n===1&&!selected.length){showError("Select at least one product before continuing.",trigger);return false}
  if(n===1 && selected.some(function(row){return !row.variant})){showError("Choose a size, colour or option for each selected product before continuing.");return false}
  if(bad){showError("Please complete all required fields correctly before continuing.",bad);return false}
  if(error){error.hidden=true;error.textContent=""}
  return true
 }
 function review(){
  var rows=[
   ["Customer",field("contact[name]")],["Request made by",requesterRole()],["Email",field("contact[email]")],["Phone",field("contact[phone]")||"Not provided"],
   ["Plan manager",field("contact[Plan management company]")],["Plan manager email",field("contact[Plan manager email]")],
   ["Products",productLines().join("; ")],["Estimated subtotal",fmt(total())],
   ["Delivery address",[field("contact[Address line 1]"),field("contact[Address line 2]"),field("contact[Suburb]"),field("contact[State]"),field("contact[Postcode]")].filter(Boolean).join(", ")]
  ];
  var target=root.querySelector("[data-ndis-review]");
  if(target){target.replaceChildren();rows.forEach(function(r){var p=el("p"),b=el("strong","",r[0]+": ");p.appendChild(b);p.appendChild(document.createTextNode(r[1]));target.appendChild(p)})}
 }
 root.querySelectorAll("[data-ndis-next]").forEach(function(b){b.addEventListener("click",function(){if(valid(step))setStep(Math.min(3,step+1))})});
 root.querySelectorAll("[data-ndis-back]").forEach(function(b){b.addEventListener("click",function(){setStep(Math.max(1,step-1))})});
 root.querySelectorAll("[data-ndis-edit]").forEach(function(b){b.addEventListener("click",function(){setStep(1)})});
 form.addEventListener("submit",async function(e){
  if(!valid(1)){e.preventDefault();setStep(1);valid(1);return}
  if(!valid(2)){e.preventDefault();setStep(2);valid(2);return}
  if(!valid(3)){e.preventDefault();setStep(3);valid(3);return}
  var lines=[
   "NDIS PLAN-MANAGED INVOICE ENQUIRY (not a confirmed order)",
   "Customer: "+field("contact[name]"),"Request made by: "+requesterRole(),"Customer email: "+field("contact[email]"),
   "Customer phone: "+field("contact[phone]"),"Preferred contact: "+field("contact[Preferred contact]"),
   "Plan management company: "+field("contact[Plan management company]"),
   "Plan manager email: "+field("contact[Plan manager email]"),
   "Plan manager contact: "+field("contact[Plan manager contact]"),
   "Selected products:",productLines().join("\n"),"Estimated total (AUD): "+fmt(total()),
   "Delivery address: "+[field("contact[Address line 1]"),field("contact[Address line 2]"),field("contact[Suburb]"),field("contact[State]"),field("contact[Postcode]")].filter(Boolean).join(", "),
   "Extra information: "+field("contact[Additional information]"),
   "Customer authorises plan manager contact: Yes",
   "Funding eligibility: subject to review. Do not dispatch solely on this enquiry."
  ];
  var body=form.elements.namedItem("contact[body]");if(body)body.value=lines.join("\n");
  var button=form.querySelector("[data-ndis-submit]");
  if(draftMode){
   e.preventDefault();
   var captcha=form.querySelector('input[name="cf-turnstile-response"]');
   if(!captcha || !captcha.value){showError("Please complete the security check before submitting.");return}
   if(selected.some(function(row){return !row.variant || !/^\d+$/.test(row.variant.id)})){showError("A selected product cannot be verified. Please contact our team.");return}
   if(button){button.disabled=true;button.textContent="Creating your NDIS draft request..."}
   try{
    var payload={
     requestId:requestId,
     customer:{name:field("contact[name]"),email:field("contact[email]"),phone:field("contact[phone]")},
     planManager:{company:field("contact[Plan management company]"),email:field("contact[Plan manager email]"),contactName:field("contact[Plan manager contact]")},
     shippingAddress:{address1:field("contact[Address line 1]"),address2:field("contact[Address line 2]"),city:field("contact[Suburb]"),provinceCode:field("contact[State]"),zip:field("contact[Postcode]")},
     items:selected.map(function(row){return {variantId:row.variant.id,quantity:row.quantity}}),
     preferredContact:field("contact[Preferred contact]"),
     notes:"Request made by: "+requesterRole()+"\n"+field("contact[Additional information]"),
     authorised:true,turnstileToken:captcha.value
    };
    var response=await fetch(endpoint,{method:"POST",headers:{"Content-Type":"application/json"},credentials:"omit",body:JSON.stringify(payload)});
    var result=await response.json().catch(function(){return {}});
    if(!response.ok||!result.success)throw new Error(result.error||"The request could not be saved.");
    var success=document.createElement("div");success.className="ndis-success";success.setAttribute("role","status");
    var heading=document.createElement("strong");heading.textContent="Your NDIS request has been received";
    var summary=document.createElement("p");summary.textContent="Your enquiry has been recorded as a draft for our team to review. No payment was taken, no invoice has been issued, and nothing has been dispatched.";
    var reference=document.createElement("p");reference.textContent="Reference: "+(result.reference||"NDIS enquiry");
    success.append(heading,summary,reference);form.replaceChildren(success);
    var stepsBar=root.querySelector(".ndis-stepper");if(stepsBar)stepsBar.hidden=true;
   }catch(err){
    showError("We couldn't save your NDIS draft request: "+(err.message||"Please try again.")+" No payment was taken.");
    if(button){button.disabled=false;button.textContent="Submit invoice request →"}
    if(window.turnstile&&typeof window.turnstile.reset==="function")window.turnstile.reset();
   }
   return;
  }
  if(button){button.disabled=true;button.textContent="Sending your request..."}
 });
 
restoreProductChoices();
refresh();
setStep(1,false);
}
function boot(){document.querySelectorAll("[data-ael-ndis]").forEach(setup)}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
document.addEventListener("shopify:section:load",boot);
})();


/* Self-managed funding guidance and checkout invoice identification.
 * Uses Shopify's public Ajax cart API; it never stores sensitive NDIS information.
 * The cart attributes travel with the checkout and are shown in order details.
 */
(function(){
  "use strict";
  function setupFunding(root){
    if(!root || root.dataset.ndisFundingReady==="1")return;
    var choiceButtons=Array.from(root.querySelectorAll("[data-ndis-funding-choice]"));
    if(!choiceButtons.length)return;
    root.dataset.ndisFundingReady="1";
    var selfPanel=root.querySelector("[data-ndis-self-panel]");
    var planPanels=Array.from(root.querySelectorAll("[data-ndis-plan-panel]"));
    var invoiceCheck=root.querySelector("[data-ndis-self-invoice]");
    var status=root.querySelector("[data-ndis-self-status]");
    var links=Array.from(root.querySelectorAll("[data-ndis-self-shop-link]"));
    var saving=false,saved=false;
    function setStatus(message,isError){
      if(!status)return;status.textContent=message;
      status.classList.toggle("is-error",!!isError);
      status.classList.toggle("is-saved",!isError && saved);
    }
    function setMode(mode){
      var self=mode==="self";
      choiceButtons.forEach(function(btn){
        var active=btn.dataset.ndisFundingChoice===mode;
        btn.setAttribute("aria-pressed",String(active));btn.classList.toggle("is-selected",active)
      });
      planPanels.forEach(function(panel){panel.hidden=self});
      if(selfPanel)selfPanel.hidden=!self;
      root.querySelectorAll("[data-ndis-copy-plan]").forEach(function(n){n.hidden=self});
      root.querySelectorAll("[data-ndis-copy-self]").forEach(function(n){n.hidden=!self});
    }
    choiceButtons.forEach(function(b){b.addEventListener("click",function(){setMode(b.dataset.ndisFundingChoice)})});
    setMode(new URLSearchParams(window.location.search).get("ndis")==="self-managed" || window.location.hash==="#self-managed"?"self":"plan");
    if(!invoiceCheck)return;
    var rootUrl=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root)||"/";
    var cartUrl=rootUrl+"cart.js",updateUrl=rootUrl+"cart/update.js";
    fetch(cartUrl,{credentials:"same-origin",headers:{"Accept":"application/json"}})
      .then(function(r){if(!r.ok)throw new Error("Cart couldn't be loaded");return r.json()})
      .then(function(cart){
        var attributes=cart.attributes||{};
        saved=attributes["NDIS Invoice Requested"]==="Yes" && attributes["NDIS Funding Management"]==="Self-managed";
        invoiceCheck.checked=saved;invoiceCheck.disabled=false;
        setStatus(saved?"Invoice request saved to your cart. It will be visible on your Shopify order.":"No invoice request selected. Tick the box if you need an NDIS invoice.",false);
      })
      .catch(function(){
        invoiceCheck.disabled=false;saved=false;
        setStatus("We couldn't check your cart preference. You can try ticking the box to save an invoice request.",true)
      });
    invoiceCheck.addEventListener("change",function(){
      if(saving)return;
      var requested=invoiceCheck.checked;
      saving=true;invoiceCheck.disabled=true;saved=false;
      setStatus("Saving your invoice preference…",false);
      fetch(updateUrl,{
        method:"POST",
        credentials:"same-origin",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({attributes:{"NDIS Invoice Requested":requested?"Yes":"","NDIS Funding Management":requested?"Self-managed":""}})
      }).then(function(r){if(!r.ok)throw new Error("Unable to save");return r.json()})
      .then(function(cart){
        var attrs=cart.attributes||{};
        if(requested && (attrs["NDIS Invoice Requested"]!=="Yes" || attrs["NDIS Funding Management"]!=="Self-managed"))throw new Error("Preference was not confirmed");
        saved=requested;invoiceCheck.checked=requested;
        setStatus(requested?"Saved! Your checkout order will include an NDIS invoice request in its details.":"Invoice request removed from your cart.",false)
      }).catch(function(){
        invoiceCheck.checked=!requested;saved=invoiceCheck.checked;
        setStatus("Your invoice preference couldn't be saved. Please try again before checking out.",true)
      }).finally(function(){saving=false;invoiceCheck.disabled=false})
    });
    links.forEach(function(link){
      link.addEventListener("click",function(e){
        if(invoiceCheck.checked && (saving||!saved)){
          e.preventDefault();
          setStatus("Please wait for the invoice request to save successfully before shopping.",true)
        }
      })
    });
  }
  function boot(){document.querySelectorAll("[data-ael-ndis]").forEach(setupFunding)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
  document.addEventListener("shopify:section:load",boot);
})();
